export default __webpack_public_path__ + "static/media/Mail.62e1c7f3.svg";